import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/utils/api'

type Args = {
  teamId: string
  memberId: string
}

export const useDeleteTeamMember = () => {
  const queryClient = useQueryClient()

  return useMutation<{ success: boolean }, Error, Args>({
    mutationFn: async ({ teamId, memberId }) => {
      const { data } = await api.delete(`/teams/${teamId}/members/${memberId}`)
      return data
    },
    onSuccess: (_, args) => {
      queryClient.invalidateQueries({ queryKey: ['team-members', args.teamId] })
    },
  })
}
